import type { CauseType, TaskPriority, TaskStatus } from '../api.js';

/**
 * The words the task screens use, in one place because the list, the forms,
 * the board and the calendar all need them.
 *
 * `MOVE_LABELS` is deliberately separate from `STATUS_LABELS`: the verb for
 * moving a task somewhere is not the name of where it lands ("Start" vs "In
 * progress"), and a button labelled with a noun reads as a filter.
 */

export const STATUS_LABELS: Readonly<Record<TaskStatus, string>> = {
  todo: 'To do',
  in_progress: 'In progress',
  blocked: 'Blocked',
  done: 'Done',
  cancelled: 'Cancelled',
};

export const MOVE_LABELS: Readonly<Record<TaskStatus, string>> = {
  todo: 'Back to to-do',
  in_progress: 'Start',
  blocked: 'Block',
  done: 'Done',
  cancelled: 'Cancel',
};

/** From the plan. "Other" carries whatever the list does not. */
export const CAUSE_LABELS: Readonly<Record<CauseType, string>> = {
  drawing: 'Waiting on a drawing',
  approval: 'Waiting on an approval',
  material: 'Waiting on a material',
  predecessor: 'Waiting on other work',
  access: 'No access to the area',
  client_decision: 'Waiting on the client',
  other: 'Something else',
};

export const PRIORITIES: readonly TaskPriority[] = ['low', 'normal', 'high', 'critical'];

export const PRIORITY_LABELS: Readonly<Record<TaskPriority, string>> = {
  low: 'Low',
  normal: 'Normal',
  high: 'High',
  critical: 'Critical',
};
